main(function (config, $, inbenta) {
    'use strict';

    var idleTime = 0;
    var timeout = 0;
    var idleInterval = null;

    $.extend(inbenta.Assistant, {
        market: null,
        universe: null,
        cr: null,
        sendData: function (data, callback, settings, bind) {
            // Add cr in all calls
            settings = $.extend({}, this.options.ajax, this.options.server, settings);
            settings.complete = callback || function () {};
            data = $.extend({}, { cr: this.cr }, data);
            settings.data = data;

            if (this.server) {
                this.server.send(settings, bind);
            } else {
                $.ajax(settings);
            }
        },
        search: function (question, ajax, div) {
            div = div ? $(div) : $('#inbenta-contents');

            // avoid searching twice
            if (this.searching) return false;

            // clean question
            question = question && $.trim(question) || '';

            // avoid searching the same twice
            if (question == this.lastQuestion) return false;

            // avoid searching with empty query
            if (!question) return false;

            this.lastQuestion = question;

            this.searching = true;

            if (ajax) {
                this.loadHtml({
                        action: 'search',
                        market: this.market,
                        univers: this.universe,
                        cr: this.cr,
                        q: question
                    },
                    div
                );
                return false;
            } else {
                return true;
            }
        },
        initJSONP: function (options) {
            var $container = $('#inbenta-compagnon-container');
            this.market = $container.attr('data-marche');
            this.universe = $container.attr('data-univers-besoin');
            this.cr = $container.attr('data-cr');
            // Check local storage for last CR value
            var lastStoredCR = window.localStorage.getItem('compagnon_lastcr');
            // clear local storage values
            window.localStorage.removeItem('compagnon_popularsexpiration');
            window.localStorage.removeItem('compagnon_populars');
            window.localStorage.removeItem('compagnon_closed');
            window.localStorage.removeItem('compagnon_closedexpiration');
            window.localStorage.removeItem('compagnon_activated');
            window.localStorage.removeItem('compagnon_delay');
            window.localStorage.removeItem('compagnon_minimized');
            // Store current cr value
            window.localStorage.setItem('compagnon_lastcr', this.cr);
            // Check local storage for closed value
            if (window.localStorage.getItem('compagnon_closed') === 'closed') {
                // Check expiration
                var expirationDateFromLocalStorage = window.localStorage.getItem(
                    'compagnon_closedexpiration');
                if (expirationDateFromLocalStorage) {
                    var expirationDateObj = new Date(expirationDateFromLocalStorage);
                    var now = new Date();
                    if (now.getTime() < expirationDateObj.getTime()) {
                        // Time not expired return without loading compagnon
                        return true; // End init loop using a true return value
                    }
                }
            }
            // Check local storage for extra info values
            var compagnonActive = window.localStorage.getItem('compagnon_activated');
            if (compagnonActive === null) {
                // Load extra infos
                this.loadHtml({
                    action: 'extraInfos',
                    cr: this.cr,
                }, null);
                return true;
            } else {
                this.processExtraInfos();
                return true;
            }
        },
        initCompagnonTimer: function () {
            // Check NPC chat content
            var npcTchat = '';
            if (document.getElementById('tchat_session')) {
                npcTchat = document.getElementById('tchat_session').innerHTML.trim();
            }
            // Get delay from extra infos
            var compagnonDelay = window.localStorage.getItem('compagnon_delay');
            if (compagnonDelay !== null && !isNaN(compagnonDelay) && compagnonDelay > 0) {
                timeout = compagnonDelay;
                idleInterval = window.setInterval(timerIncrement, 1000);
            } else if (npcTchat === '') {
                this.loadCompagnon();
            }
        },
        processExtraInfos: function () {
            var compagnonActive = window.localStorage.getItem('compagnon_activated');
            if (compagnonActive === 'Non') {
                console.log('compagnon is not active...');
                return true;
            }
            var currentPopular = this.getCurrentUsedPopular();
            if (currentPopular === null) {
                // first time loading the compagnon
                this.initCompagnonTimer();
            } else {
                // already an existing compagnon
                this.loadCompagnon();
            }
        },
        loadCompagnon: function () {
            if ($('#inbenta-compagnon-container').length) {
                // Insert compagnon html in target div
                var compagnonHTML = '';
                if (window.location.href.indexOf('www.credit-agricole.fr') > -1) {
                    compagnonHTML = '<div id="inbenta-compagnon" class="inbenta-interface inbenta-jsonp" role="region" aria-live="assertive" style=""><div class="GreenBtn-chatBoxReduced GreenBtn-chatBoxReduced--help"><div class="GreenBtn-chatBoxReducedIconWrapper"> <span class="GreenBtn-chatBoxReducedIcon icon npc-help"></span><div class="GreenBtn-chatBoxReducedTriangle hidden-xs hidden-sm"></div></div><div class="GreenBtn-chatBoxUnfolded GreenBtn-chatBoxUnfolded--greenBg"><div class="GreenBtn-chatBoxUnfoldedText"> Avez-vous besoin d\'aide ?</div><div class="GreenBtn-chatBoxUnfoldedBtnWrapper"> <span> <a href="#" class="open-compagnon btn btn-default GreenBtn-chatBoxUnfoldedBtn GreenBtn-chatBoxUnfoldedBtn--active" data-trackingclass="popup_assistant" title="Avez-vous besoin d\'aide ? Oui, j\'en ai besoin"> Oui</a> </span> <span> <a href="#" class="close-compagnon btn btn-default GreenBtn-chatBoxUnfoldedBtn" title="Non merci"> Non</a> </span></div></div></div><div class="GreenBtn-dialogBox GreenBtn-dialogBox--help hidden"><div class="GreenBtn-dialogBoxHeader"><div class="GreenBtn-dialogBoxHeaderTitleWrapper"> <span class="GreenBtn-dialogBoxHeaderTitleIcon icon npc-help"></span> <span class="GreenBtn-dialogBoxHeaderTitle"> AVEZ-VOUS BESOIN D\'AIDE ?</span></div><div class="GreenBtn-dialogBoxHeaderOptionWrapper"> <span class="minimize-compagnon"><a href="#" class="GreenBtn-dialogBoxHeaderOptionReduce icon npc-substract" role="button" aria-label="Je souhaite mettre en veille&nbsp;le compagnon d’aide"></a></span> <span class="close-compagnon"><a href="#" class="GreenBtn-dialogBoxHeaderOptionClose icon npc-close" role="button" aria-label="Je souhaite fermer le compagnon d’aide"></a></span></div></div><div id="inbenta-contents" class="GreenBtn-dialogBoxContent"></div><div class="GreenBtn-dialogBoxFooter GreenBtn-dialogBoxFooter--links hidden"> <a href="#" class="GreenBtn-dialogBoxFooterLink GreenBtn-dialogBoxFooterLink--prev">Retour</a> <a href="#" class="GreenBtn-dialogBoxFooterLink GreenBtn-dialogBoxFooterLink--next generateLink" data-linktarget="category=6">Voir toutes les réponses</a></div><form class="GreenBtn-dialogBoxFooter search-form ajax-form" action="https://credit_agricole_compagnon.inbenta.com/" method="get" accept-charset="UTF-8"> <input class="question-input GreenBtn-dialogBoxFooterUserMessage" name="q" type="text" autocomplete="off" placeholder="Posez votre question" title="Posez votre question" iaf-disableonload=""> <a href="#" class="search-btn GreenBtn-dialogBoxFooterSend" iaf-disableonload="">Envoyer</a></form><div class="GreenBtn-dialogBoxTriangle hidden-xs hidden-sm"></div></div></div>';
                } else {
                    compagnonHTML = '<div id="inbenta-compagnon" class="inbenta-interface inbenta-jsonp" role="region" aria-live="assertive" style=""><div class="GreenBtn-chatBoxReduced GreenBtn-chatBoxReduced--help"><div class="GreenBtn-chatBoxReducedIconWrapper"> <span class="GreenBtn-chatBoxReducedIcon icon npc-help"></span><div class="GreenBtn-chatBoxReducedTriangle hidden-xs hidden-sm"></div></div><div class="GreenBtn-chatBoxUnfolded GreenBtn-chatBoxUnfolded--greenBg"><div class="GreenBtn-chatBoxUnfoldedText"> Avez-vous besoin d\'aide ?</div><div class="GreenBtn-chatBoxUnfoldedBtnWrapper"> <span> <a href="#" class="open-compagnon btn btn-default GreenBtn-chatBoxUnfoldedBtn GreenBtn-chatBoxUnfoldedBtn--active" data-trackingclass="popup_assistant" title="Avez-vous besoin d\'aide ? Oui, j\'en ai besoin"> Oui</a> </span> <span> <a href="#" class="close-compagnon btn btn-default GreenBtn-chatBoxUnfoldedBtn" title="Non merci"> Non</a> </span></div></div></div><div class="GreenBtn-dialogBox GreenBtn-dialogBox--help hidden"><div class="GreenBtn-dialogBoxHeader"><div class="GreenBtn-dialogBoxHeaderTitleWrapper"> <span class="GreenBtn-dialogBoxHeaderTitleIcon icon npc-help"></span> <span class="GreenBtn-dialogBoxHeaderTitle"> AVEZ-VOUS BESOIN D\'AIDE ?</span></div><div class="GreenBtn-dialogBoxHeaderOptionWrapper"> <span class="minimize-compagnon"><a href="#" class="GreenBtn-dialogBoxHeaderOptionReduce icon npc-substract" role="button" aria-label="Je souhaite mettre en veille&nbsp;le compagnon d’aide"></a></span> <span class="close-compagnon"><a href="#" class="GreenBtn-dialogBoxHeaderOptionClose icon npc-close" role="button" aria-label="Je souhaite fermer le compagnon d’aide"></a></span></div></div><div id="inbenta-contents" class="GreenBtn-dialogBoxContent"></div><div class="GreenBtn-dialogBoxFooter GreenBtn-dialogBoxFooter--links hidden"> <a href="#" class="GreenBtn-dialogBoxFooterLink GreenBtn-dialogBoxFooterLink--prev">Retour</a> <a href="#" class="GreenBtn-dialogBoxFooterLink GreenBtn-dialogBoxFooterLink--next generateLink" data-linktarget="category=6">Voir toutes les réponses</a></div><form class="GreenBtn-dialogBoxFooter search-form ajax-form" action="https://f01.inbenta.com/credit_agricole_compagnon/" method="get" accept-charset="UTF-8"> <input class="question-input GreenBtn-dialogBoxFooterUserMessage" name="q" type="text" autocomplete="off" placeholder="Posez votre question" title="Posez votre question" iaf-disableonload=""> <a href="#" class="search-btn GreenBtn-dialogBoxFooterSend" iaf-disableonload="">Envoyer</a></form><div class="GreenBtn-dialogBoxTriangle hidden-xs hidden-sm"></div></div></div>';
                }
                var customResponse = {
                    html: compagnonHTML,
                    action: 'load',
                    callbackData: {
                        div: $('#inbenta-compagnon-container'),
                    }
                }
                this.updateInterface(customResponse);
                return true;
            }
        },
        /**
         * Get the current url string
         *
         * @return {string}
         */
        getCurrentUrl: function () {
            return window.location.origin + window.location.pathname;
        },
        /**
         * Return the matched custom popular from extra info from the current url
         *
         * @return {?{active: string, category: string, contents: string, order: string, url: string}}
         */
        getCompagnonUrlsFromUrl: function () {
            var currentUrl = this.getCurrentUrl();
            var compagnonUrls = JSON.parse(window.localStorage.getItem('compagnon_urls'));
            var matchUrl = null;
            if (compagnonUrls) {
                matchUrl = compagnonUrls.filter(function (pattern) {
                    return pattern.url === currentUrl;
                });
                matchUrl = matchUrl.length > 0 ? matchUrl[0] : null;
            }
            return matchUrl;
        },
        /**
         * Return the matched save popular from the current url
         *
         * @return {?{html: string, url: string, minimized: string}}
         */
        getSavedPopularFromUrl: function () {
            var currentUrl = this.getCurrentUrl();
            var savedPopulars = JSON.parse(window.localStorage.getItem('compagnon_populars'));
            var matchSavedPopulars = null;
            if (savedPopulars) {
                matchSavedPopulars = savedPopulars.filter(function (save) {
                    return save.url === currentUrl;
                });
                matchSavedPopulars = matchSavedPopulars.length > 0 ? matchSavedPopulars[0] : null;
            }
            return matchSavedPopulars;
        },
        /**
         * Return the default saved popular
         *
         * @return {?{html: string, minimized: string}}
         */
        getDefaultSavedPopular: function () {
            return JSON.parse(window.localStorage.getItem('compagnon_populars_default'));
        },
        /**
         * Return the current used popular from cache
         *
         * @return {?{html: string, minimized: string}|?{html: string, url: string, minimized: string}}
         */
        getCurrentUsedPopular: function () {
            var perUrl = this.getSavedPopularFromUrl();
            return perUrl ? perUrl : this.getDefaultSavedPopular();
        },
        savePopularHtml: function (html) {
            // save the HTML
            var currentUrl = this.getCurrentUrl();
            var matchFromExtraInfo = this.getCompagnonUrlsFromUrl();
            if (matchFromExtraInfo !== null) {
                // save in the `compagnon_populars`
                var populars = JSON.parse(window.localStorage.getItem('compagnon_populars'));
                if (!populars) {
                    populars = [];
                }
                populars.push({
                    url: currentUrl,
                    html: html,
                    minimized: true,
                });
                window.localStorage.setItem('compagnon_populars', JSON.stringify(populars));
            } else {
                // not a custom popular, save in the `compagnon_populars_default`
                window.localStorage.setItem('compagnon_populars_default', JSON.stringify({
                    html: html,
                    minimized: true,
                }));
            }
            // set expiration
            var popularExpirationDate = new Date();
            popularExpirationDate.setTime(popularExpirationDate.getTime() + (48 * 60 * 60 * 1000));
            window.localStorage.setItem('compagnon_popularsexpiration', popularExpirationDate);
        },
        updateCurrentPopular: function (data) {
            if (!data) {
                data = {};
            }
            var currentPopular = this.getCurrentUsedPopular();

            if (!currentPopular) {
                this.loadPopularFromLocalStorage();
                return;
            }

            if (currentPopular.url) {
                // custom per url
                currentPopular = $.extend({}, currentPopular, data);
                var populars = JSON.parse(window.localStorage.getItem('compagnon_populars'));
                $.each(populars, function (index, popular) {
                    if (popular.url === currentPopular.url) {
                        populars[index] = currentPopular;
                    }
                })
                window.localStorage.setItem('compagnon_populars', JSON.stringify(populars));
            } else {
                // default popular
                currentPopular = $.extend({}, currentPopular, data);
                window.localStorage.setItem('compagnon_populars_default',
                    JSON.stringify(currentPopular));
            }

        },
        loadPopularFromLocalStorage: function () {
            // Check local storage for populars
            var $inbentaContents = $('#inbenta-contents');
            // get the current url
            var currentUrl = this.getCurrentUrl();
            // get the current popular from cache
            var currentPopular = this.getCurrentUsedPopular();
            // check if we have a saved value so we can load the HTML from the cache directly
            if (currentPopular !== null) {
                var savedPopularsExpiration = window.localStorage.getItem(
                    'compagnon_popularsexpiration');
                if (savedPopularsExpiration) {
                    // Check if stored populars are not stale
                    var popularExpirationDateObj = new Date(savedPopularsExpiration);
                    var now = new Date();
                    if (now.getTime() < popularExpirationDateObj.getTime()) {
                        // not expired
                        var customPopularResponse = {
                            action: 'customPopular',
                            html: currentPopular.html,
                            callbackData: {
                                div: $inbentaContents,
                            }
                        }
                        if (currentPopular.url) { // give url just in case if possible
                            customPopularResponse.callbackData.url = currentPopular.url;
                        }
                        inbenta.Assistant.updateInterface(customPopularResponse);
                        return true;
                    } else {
                        // Clear populars from localStorage
                        window.localStorage.removeItem('compagnon_popularsexpiration');
                        window.localStorage.removeItem('compagnon_populars');
                        window.localStorage.removeItem('compagnon_populars_default');
                    }
                }
            }
            // else, load popular from server
            this.loadHtml({
                action: 'popular',
                view: 1,
                market: this.market,
                univers: this.universe,
                cr: this.cr,
                url: currentUrl,
            },
            $inbentaContents);
        },
        updateInterface: function (response) {
            if (!response) return;
            if (response.html && response.callbackData && response.callbackData.div) {
                response.callbackData.div.html(response.html);
            }

            var that = this;
            var handlePopular = function (response) {
                if (response.html === '') {
                    $('#inbenta-compagnon').remove();
                } else {
                    $('#inbenta-compagnon').show();
                    // If compagnon is shown
                    var currentPopular = that.getCurrentUsedPopular();
                    if (currentPopular && currentPopular.minimized === false) {
                        $('.GreenBtn-chatBoxReduced').addClass('hidden');
                        $('.GreenBtn-dialogBox').removeClass('hidden');
                        $('.question-input').focus();
                        // Set focus on first answer
                        if ($('.faq-link.clicable').length > 0) {
                            $('.faq-link.clicable').first().focus();
                        }
                    }
                    // Save popular to localStorage with a 48h expiration date
                    if (response.action === 'popular') {
                        that.savePopularHtml(response.html);
                    }
                }
            };

            switch (response.action) {
                case 'search':
                    this.searching = false;
                    $('.search-form [iaf-disableonload]').removeAttr('disabled');
                    // Set focus on first answer
                    if ($('.faq-link.clicable').length > 0) {
                        $('.faq-link.clicable').first().focus();
                    }
                    break;

                case 'extraInfos':
                    // Save extra infos
                    var infos = JSON.parse(response.html);
                    window.localStorage.setItem('compagnon_activated', infos.active);
                    window.localStorage.setItem('compagnon_delay', infos.timeout);
                    window.localStorage.setItem('compagnon_urls', JSON.stringify(infos.urls));
                    // If compagnon is active, launch it
                    this.processExtraInfos();
                    break;

                case 'popular':
                    handlePopular(response);
                    break;
                case 'customPopular':
                    handlePopular(response);
                    break;
            }

            this.hideLoader(response);
            $('.inbenta-rating').inbentaRatingCompagnon();
            // Generate link targets
            generateLinks();
            $(document).trigger('inbenta.html.load');
        }
    });

    var timerIncrement = function () {
        //Check NPC tchat status
        var npcTchatContent = "";
        if (document.getElementById('tchat_session')) {
            npcTchatContent = document.getElementById('tchat_session').innerHTML.trim();
        }
        if (npcTchatContent != '') {
            // If tchat not empty, abort compagnon loading
            window.clearInterval(idleInterval);
        } else {
            idleTime = idleTime + 1;
            if (idleTime > timeout) {
                inbenta.Assistant.loadCompagnon();
                window.clearInterval(idleInterval);
            }
        }
    }

    $(document).mousemove(function (e) {
        idleTime = 0;
    });
    $(document).keypress(function (e) {
        idleTime = 0;
    });

    // Hack to prevent iOS bug
    var focused = false;
    var virtualKeyboardHeight = function () {
        var sx = document.body.scrollLeft, sy = document.body.scrollTop;
        var naturalHeight = window.innerHeight;
        window.scrollTo(sx, document.body.scrollHeight);
        var keyboardHeight = naturalHeight - window.innerHeight;
        window.scrollTo(sx, sy);
        return keyboardHeight;
    };
    // Asked by the client
    $(document).on('focus',
        '#inbenta-compagnon .question-input.GreenBtn-dialogBoxFooterUserMessage',
        function () {
            focused = true;
            setTimeout(function () {
                virtualKeyboardHeight();
            }, 1);
        });
    $(document).on('resize', function () {
        if (focused) {
            virtualKeyboardHeight();
        }
    });
    $(document).on('blur',
        '#inbenta-compagnon .question-input.GreenBtn-dialogBoxFooterUserMessage',
        function () {
            focused = false;
        });

    // Opens widget
    $(document).on('click', '.open-compagnon', function (e) {
        e.preventDefault();
        // Check NPC chat content
        var npcTchat = '';
        if (document.getElementById('tchat_session')) {
            npcTchat = document.getElementById('tchat_session').innerHTML.trim();
        }
        if (npcTchat === '') {
            inbenta.Assistant.loadPopularFromLocalStorage();
        }
        $(document).trigger('inbenta.compagnon.toggle', { minimized: false });
    });
    // Minimize widget
    $(document).on('click', '.minimize-compagnon', function (e) {
        e.preventDefault();
        $(document).trigger('inbenta.compagnon.toggle', { minimized: true });
    });
    // Handle toggle compagnon event
    $(document).on('inbenta.compagnon.toggle', function (e, data) {
        var $dialogBox = $('.GreenBtn-dialogBox');
        var $chatBoxReduced = $('.GreenBtn-chatBoxReduced');
        if (data.minimized) { // reducing the compagnon
            inbenta.Assistant.updateCurrentPopular({ minimized: true })
            $dialogBox.addClass('hidden');
            $chatBoxReduced.removeClass('hidden');
        } else { // opening the compagnon
            inbenta.Assistant.updateCurrentPopular({ minimized: false })
            $chatBoxReduced.addClass('hidden');
            $dialogBox.removeClass('hidden');
            $('.question-input').focus();
            // trigger event to enable tracking
            var event = new Event('recherche_popup');
            document.dispatchEvent(event);
        }
    });
    // Close widget
    $(document).on('click', '.close-compagnon', function (e) {
        e.preventDefault();
        window.localStorage.setItem('compagnon_closed', 'closed');
        var expirationDate = new Date();
        // Set session expiration at now + 48h (48h x 60min x 60sec x 1000ms)
        expirationDate.setTime(expirationDate.getTime() + (48 * 60 * 60 * 1000));
        // Store expiration date
        window.localStorage.setItem('compagnon_closedexpiration', expirationDate);
        $('#inbenta-compagnon').remove();
    });
    $(document).on('click', '.search-btn', function (e) {
        e.preventDefault();
        $('#inbenta-compagnon .search-form').trigger('submit');
    });
    var This = this;
    $(document).on('click', '.rating-link', function (e) {
        e.preventDefault();
        var type = 'rating-content';
        var idata = e.target.getAttribute('value');
        inbenta.Assistant.sendData({
            action: type,
            idata: idata
        });
        $(this).next().trigger('click');
    });
    $(document).on('click', '.faq-link', function (e) {
        e.preventDefault();
        $('.GreenBtn-helpTitle').addClass('hidden');
        $('.faq-link').addClass('hidden');
        $('.search-form').addClass('hidden');
        $('.GreenBtn-dialogBoxFooter--links').removeClass('hidden');
        $('.GreenBtn-dialogBox').addClass('GreenBtn-dialogBox--whiteTriangle');
        $(this).next().removeClass('hidden');
    });
    $(document).on('click', '.GreenBtn-dialogBoxFooterLink--prev', function (e) {
        e.preventDefault();
        $('.GreenBtn-helpTitle').removeClass('hidden');
        $('.faq-link').removeClass('hidden');
        $('.search-form').removeClass('hidden');
        $('.GreenBtn-dialogBoxFooter--links').addClass('hidden');
        $('.GreenBtn-dialogBox').removeClass('GreenBtn-dialogBox--whiteTriangle');
        $('.GreenBtn-dialogBoxFAQ').addClass('hidden');
    });

    $(window).on("npcTchat.ouvert", function () {
        $('#inbenta-compagnon').remove();
    });

    inbenta.Assistant.initialize({
        jsonp: true,
        server: {
            url: inbenta.baseURL,
            sessionName: 'inbenta-iaf-jsonp'
        }
    });

    inbenta.Assistant.loadJSONPInterface();

    function generateLinks() {
        // Use generateURL function to set links targets
        if (window.NPC && window.NPC.recupererUrlFaq) {
            var link = window.NPC.recupererUrlFaq();
            // Trim trailing #
            link.replace(/#$/, '');
        } else {
            link = '';
        }

        // Replace "generateLink" targets
        $('.generateLink').each(function (i, o) {
            if ($(o).attr('data-linktarget')) {
                // Split additionnal params string to check param not already in target
                var linkTargetParams = $(o).attr('data-linktarget').split('&');
                linkTargetParams.forEach(function (elem) {
                    var keyVal = elem.split("=");
                    link = updateQueryStringParameter(link, keyVal[0], keyVal[1]);
                });
            }
            $(o).attr('href', link);
            $(o).removeClass('generateLink');
        });
    }

    function updateQueryStringParameter(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            return uri + separator + key + "=" + value;
        }
    }
}, window.jQuery, window.InbentaCompagnon || {});
